import { render, staticRenderFns } from "./FirmContact.vue?vue&type=template&id=c92c65a4&"
import script from "./FirmContact.vue?vue&type=script&lang=js&"
export * from "./FirmContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports